import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bf9228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loby-logo" }, null, -1))
const _hoisted_3 = { class: "info user-name" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "info user-coin" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_8 = { class: "value-btns" }
const _hoisted_9 = { class: "value-btns" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "m-header" }
const _hoisted_12 = { class: "m-header-top" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-logo" }, null, -1))
const _hoisted_14 = { class: "info user-name" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info user-coin" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-fill" }, null, -1))
const _hoisted_19 = { class: "m-header-bottom" }
const _hoisted_20 = { class: "m-tab-menu" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-fill" }, null, -1))
const _hoisted_22 = { class: "m-limit" }
const _hoisted_23 = { class: "content-wrap" }
const _hoisted_24 = {
  key: 0,
  class: "content"
}
const _hoisted_25 = {
  key: 0,
  class: "multi-select-footer-info"
}
const _hoisted_26 = ["data-info"]
const _hoisted_27 = {
  key: 0,
  class: "content multi"
}
const _hoisted_28 = { class: "multi-table-betting" }
const _hoisted_29 = { class: "multi-item-group" }
const _hoisted_30 = { class: "chips-group-control" }
const _hoisted_31 = { class: "m-content-wrap" }
const _hoisted_32 = { class: "m-content" }
const _hoisted_33 = { class: "footer" }
const _hoisted_34 = {
  key: 0,
  class: "promotion-pop-details"
}
const _hoisted_35 = {
  key: 0,
  class: "promotion-pop-details-content"
}
const _hoisted_36 = { class: "title-wrap" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "body-wrap" }
const _hoisted_39 = {
  key: 0,
  class: "content-d"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "USDT存款加贈>最高5%彩金", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活動時間>", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2024.06.15起", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活動對象>", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "所有會員", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活動内容>", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 達標情況:轉碼一倍達標後，即時送出本金的百分之五(即送出:0.05萬USDT) ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 不達標情況:轉碼不夠本金之一倍，即按轉碼量的百分之五(例:本金1萬USDT,轉碼0.8萬，即送出:0.04萬USDT) ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 優惠期間所有USDT提取不收任何手續費，直至另行通知 ", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注意事項:", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 達標按本金計算百分之五送出，不達標按轉碼的百分之五送出, 送出部份不設提款條件限制; 每次存入為開始，提款時按達標與否來判斷送出之结算方式. ", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "例:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一:存入1萬，轉碼達標後取款時即時送出.", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 二:存入1萬，轉碼0.7萬，不達標取款時按轉碼0.7萬的5%送出 ", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 三:存入1萬，再存入1萬，轉碼達標2萬後取款時送出 ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 四:存入1萬, 再存入1萬, 轉碼1.5萬, 不達標取款時轉碼1.5萬的5%送出 ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 五:存入3萬，轉碼2萬,中途提款但轉碼不達標，取款時按轉碼2萬的5%送出 ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "代理線客户不列入本公司活動對象", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 以上優惠須USDT進、USDT出，任何提款動作，優惠將重新計算 ", -1))
const _hoisted_67 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63,
  _hoisted_64,
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = {
  key: 1,
  class: "content-d"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "USDT存款加赠>最高5%彩金", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活动时间>", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2024.06.15起", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活动对象>", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "所有会员", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活动内容>", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 达标情况:转码一倍达标后，即时送出本金的百分之五(即送出:0.05万USDT) ", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 不达标情况:转码不够本金之一倍，即按转码量的百分之五(例:本金1万USDT,转码0.8万，即送出:0.04万USDT) ", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 优惠期间所有USDT提款不收任何手续费，直至另行通知 ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注意事项:", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 达标按本金计算百分之五送出，不达标按转码的百分之五送出送出部份不设提款条件限制; 每次存入为开始，提款时按达标与否来判断送出之结算方式. ", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "例:", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一:存入1万，转码达标后取款时即时送出.", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 二:存入1万，转码0.7万，不达标取款时按转码0.7万的5%送出 ", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 三:存入1万，再存入1万，转码达标2万后取款时送出 ", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 四:存入1万，再存入1万，转码1.5万，不达标取款时按 ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "转码1.5万的5%送出.", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 五:存入3万，转码2万,中途提款但转码不达，取款时按转码2万的5%送出 ", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "代理线客户不列入本公司活动对象", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 以上优惠须USDT进、USDT出，任何提款动作，优惠将重新计算 ", -1))
const _hoisted_97 = [
  _hoisted_69,
  _hoisted_70,
  _hoisted_71,
  _hoisted_72,
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76,
  _hoisted_77,
  _hoisted_78,
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82,
  _hoisted_83,
  _hoisted_84,
  _hoisted_85,
  _hoisted_86,
  _hoisted_87,
  _hoisted_88,
  _hoisted_89,
  _hoisted_90,
  _hoisted_91,
  _hoisted_92,
  _hoisted_93,
  _hoisted_94,
  _hoisted_95,
  _hoisted_96
]
const _hoisted_98 = {
  key: 1,
  class: "promotion-pop-details-content"
}
const _hoisted_99 = { class: "title-wrap" }
const _hoisted_100 = { class: "title" }
const _hoisted_101 = { class: "body-wrap" }
const _hoisted_102 = {
  key: 0,
  class: "content-d"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" 連續簽到最高>最高"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "2776"),
  /*#__PURE__*/_createTextVNode("獎勵金 ")
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活動時間>", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2024.06.15起", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活動内容>", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 1.連續 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "5"),
  /*#__PURE__*/_createTextVNode(" 天遊戲簽到送獎勵金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "288")
], -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 2.連續 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "10"),
  /*#__PURE__*/_createTextVNode(" 天遊戲簽到送獎勵金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "888")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 3.連續 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "20"),
  /*#__PURE__*/_createTextVNode(" 天遊戲簽到送獎勵金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "1888")
], -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "每日簽到需遊戲3局以上，視爲完成簽到", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "簽到獎勵金每月結算，於次月3日發放", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " （代理線客戶不列入本公司活動對象）", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<條款與規則>", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.會員指定有效投注均由系統自動統計，若有任何異議，依照歐盈娛樂查詢結果為準。 ", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 2.本活動僅計算有效轉碼量，無風險投注不計入有效轉碼。（無風險投注包括於百家樂同時押莊家及閒家...等）。 ", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 3.每一個賬戶僅申請一次。如發現異常或者有其他任何套利行爲，將取消活動資格。 ", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 4.歐盈娛樂的所有優惠特為玩家而設，如發現任何團體或個人以不誠實方式套取紅利或任何威脅、濫用公司優惠等行為，公司保留凍結、取消該團體或個人賬戶及賬戶結餘的權利。 ", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 5.歐盈娛樂對本活動保有最終解釋權，有權在任何時間修改、暫停或取消優惠活動。 ", -1))
const _hoisted_122 = [
  _hoisted_103,
  _hoisted_104,
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108,
  _hoisted_109,
  _hoisted_110,
  _hoisted_111,
  _hoisted_112,
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116,
  _hoisted_117,
  _hoisted_118,
  _hoisted_119,
  _hoisted_120,
  _hoisted_121
]
const _hoisted_123 = {
  key: 1,
  class: "content-d"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" 连续签到最高>最高"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "2776"),
  /*#__PURE__*/_createTextVNode("奖励金 ")
], -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活动时间>", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2024.06.15起", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<活动内容>", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 1.连续 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "5"),
  /*#__PURE__*/_createTextVNode(" 天游戏签到送奖励金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "288")
], -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 2.连续 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "10"),
  /*#__PURE__*/_createTextVNode(" 天游戏签到送奖励金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "888")
], -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 3.连续 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "20"),
  /*#__PURE__*/_createTextVNode(" 天游戏签到送奖励金 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffbc00"} }, "1888")
], -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "每日签到需游戏3局以上，视为完成签到", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "签到奖励金每月结算，于次月3日发放", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " （代理线客户不列入本公司活动对象）", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "<条款与规则>", -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.会员指定有效投注均由系统自动统计，若有任何异议，依照欧盈娱乐查询结果为准。 ", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 2.本活动仅计算有效转码量，无风险投注不计入有效转码。 （无风险投注包括于百家乐同时押庄家及闲家...等）。 ", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 3.每一个账户仅申请一次。如发现异常或者有其他任何套利行为，将取消活动资格。 ", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 4.欧盈娱乐的所有优惠特为玩家而设，如发现任何团体或个人以不诚实方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。 ", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 5.欧盈娱乐对本活动保有最终解释权，有权在任何时间修改、暂停或取消优惠活动。 ", -1))
const _hoisted_143 = [
  _hoisted_124,
  _hoisted_125,
  _hoisted_126,
  _hoisted_127,
  _hoisted_128,
  _hoisted_129,
  _hoisted_130,
  _hoisted_131,
  _hoisted_132,
  _hoisted_133,
  _hoisted_134,
  _hoisted_135,
  _hoisted_136,
  _hoisted_137,
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_ctrl_dropdown = _resolveComponent("ctrl-dropdown")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_i_one_bar = _resolveComponent("i-one-bar")!
  const _component_i_two_bar = _resolveComponent("i-two-bar")!
  const _component_i_full = _resolveComponent("i-full")!
  const _component_i_normal = _resolveComponent("i-normal")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_list_item = _resolveComponent("list-item")!
  const _component_multi_table_item = _resolveComponent("multi-table-item")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_m_list_item = _resolveComponent("m-list-item")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_promo_pop = _resolveComponent("promo-pop")!

  return (_openBlock(), _createElementBlock("div", {
    class: "loby-root",
    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.resetTimeoutCountDown && _ctx.resetTimeoutCountDown(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.coin), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-menu", { 'is-mobile': _ctx.isMobile }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 0 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDeskFilter(0)))
        }, _toDisplayString(_ctx.t('loby.all')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item btn mid_item", { active: _ctx.tabId === 1 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDeskFilter(1)))
        }, _toDisplayString(_ctx.t('loby.baccarattable')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item btn mid_item", { active: _ctx.tabId === 2 }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDeskFilter(2)))
        }, _toDisplayString(_ctx.t('loby.dragontigertable')), 3),
        (_ctx.commandType === 2 && !_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 3 }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeDeskFilter(3)))
            }, _toDisplayString(_ctx.t('loby.multiple')), 3))
          : _createCommentVNode("", true)
      ], 2),
      _hoisted_7,
      (_ctx.tabId !== 3)
        ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
            key: 0,
            class: "drop-down-game-limit",
            listData: _ctx.limitOptionArray,
            modelValue: _ctx.limitOption,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limitOption) = $event))
          }, null, 8, ["listData", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (
                    _ctx.tabId === 3 &&
                    _ctx.isMultitbableView &&
                    _ctx.getMultitableIds() !== '' && !_ctx.isFreeUser
                )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-ss",
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
              }, [
                _createVNode(_component_i_balance_g, { class: "icon-btns" }),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('dialogs.tip')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (
                _ctx.tabId === 3 &&
                _ctx.isMultitbableView &&
                _ctx.getMultitableIds() !== ''
            )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn-ss btn-switch-playmode",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_i_one_bar, {
        class: _normalizeClass(["icon one-bar", { active: _ctx.listDisplayType === 0 }]),
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(0)), ["prevent"]))
      }, null, 8, ["class"]),
      _createVNode(_component_i_two_bar, {
        class: _normalizeClass(["icon two-bar", { active: _ctx.listDisplayType === 1 }]),
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(1)), ["prevent"]))
      }, null, 8, ["class"]),
      (!_ctx.isfullScreen && _ctx.fullScreenAvailable)
        ? (_openBlock(), _createBlock(_component_i_full, {
            key: 2,
            class: "icon full",
            onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
          }, null, 8, ["onClick"]))
        : (_ctx.isfullScreen && _ctx.fullScreenAvailable)
          ? (_openBlock(), _createBlock(_component_i_normal, {
              key: 3,
              class: "icon normal",
              onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('loby.menu')), 1),
        _createVNode(_component_i_arrow_h, {
          class: "icon-arrow",
          color: '#854b97'
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_i_user_l, { class: "icon user-l" }),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.user), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_i_balance, { class: "icon balance" }),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.coin), 1)
        ]),
        _hoisted_18,
        _createElementVNode("div", {
          class: "m-menu",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
        }, [
          _createVNode(_component_icon_menu),
          _createElementVNode("span", null, _toDisplayString(_ctx.t('common.more')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 0 }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeDeskFilter(0)))
          }, _toDisplayString(_ctx.t('loby.all')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item btn mid_item", { active: _ctx.tabId === 1 }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeDeskFilter(1)))
          }, _toDisplayString(_ctx.t('loby.baccarattable')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item btn mid_item", { active: _ctx.tabId === 2 }]),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeDeskFilter(2)))
          }, _toDisplayString(_ctx.t('loby.dragontigertable')), 3),
          (_ctx.commandType === 2 && !_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 3 }]),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeDeskFilter(3)))
              }, _toDisplayString(_ctx.t('loby.multiple')), 3))
            : _createCommentVNode("", true)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t('multibetting.redlimit')), 1),
          (_ctx.tabId !== 3)
            ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
                key: 0,
                class: "drop-down-game-limit",
                listData: _ctx.limitOptionArray,
                modelValue: _ctx.limitOption,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.limitOption) = $event))
              }, null, 8, ["listData", "modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withCtx(() => [
          (!_ctx.isMultitbableView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(), _createElementBlock("div", {
                  class: "content-list",
                  key: _ctx.listKey
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDesk, (desk) => {
                    return (_openBlock(), _createBlock(_component_list_item, {
                      class: _normalizeClass(["content-list-item", {
                            'grid-3': _ctx.listDisplayType === 1,
                            'selected':
                                _ctx.tabId === 3 &&
                                _ctx.multiTableSelected.indexOf(desk.id) !== -1
                        }]),
                      key: desk.id,
                      mData: desk,
                      activeDesk: _ctx.currentDeskNo,
                      displayType: _ctx.listDisplayType,
                      onClick: ($event: any) => (_ctx.handleSelectDesk(desk.id, desk))
                    }, null, 8, ["class", "mData", "activeDesk", "displayType", "onClick"]))
                  }), 128))
                ])),
                (!_ctx.isMultitbableView && _ctx.tabId === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: "start-multi-betting",
                        "data-info": _ctx.multiTableSelectTip(),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.gotoMultitableView()))
                      }, _toDisplayString(_ctx.t('loby.startmultibetting')), 9, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "slide-up" }, {
        default: _withCtx(() => [
          (_ctx.isMultitbableView && !_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk1,
                      position: 0,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk2,
                      position: 1,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk3,
                      position: 2,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk4,
                      position: 3,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_ctrl_chips, { class: "chips-group" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDesk, (desk) => {
          return (_openBlock(), _createBlock(_component_m_list_item, {
            class: "m-list-item",
            activeDesk: _ctx.currentDeskNo,
            mData: desk,
            key: `m-list-item${desk.id}`,
            onClick: ($event: any) => (_ctx.visitDesk(desk.id, desk))
          }, null, 8, ["activeDesk", "mData", "onClick"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "m-notice",
        speed: 30,
        key: _ctx.noticeKey
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.lobyNotice), 1)
        ]),
        _: 1
      }))
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showPromotionPop)
          ? (_openBlock(), _createBlock(_component_promo_pop, {
              key: 0,
              class: "prmotion-pop",
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPromotionPop = false)),
              onViewDetails: _ctx.viewPromoDetails
            }, null, 8, ["onViewDetails"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showPromotionPopDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              (_ctx.promoActivepage === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.lang === 'zh-hk'
                                    ? '【存款回饋】USDT限定'
                                    : '【存款回馈】USDT限定'), 1),
                      _createElementVNode("div", {
                        class: "close-btn",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPromotionPopDetails = false))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      (_ctx.lang === 'zh-hk')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_67))
                        : (_ctx.lang === 'zh-cn')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_97))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                : (_ctx.promoActivepage === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.lang === 'zh-hk'
                                    ? '連續簽到獎勵金'
                                    : '连续签到奖励金'), 1),
                        _createElementVNode("div", {
                          class: "close-btn",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPromotionPopDetails = false))
                        })
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        (_ctx.lang === 'zh-hk')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, _hoisted_122))
                          : (_ctx.lang === 'zh-cn')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_123, _hoisted_143))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}